import { defineStore } from 'pinia'
import useCrudStore from '@/hooks/useCrudStore'
import { fetchItems, updateItem } from '@/apps/traforama/api/retargetingLists'

const defaultFilter = {}

export const useRetargetingListsStore = defineStore('retargetingLists', () => {
  const {
    currentItems,
    total,
    filter,
    listLoading,
    currentPage,
    FetchItems,
    SetCurrentPage,
    SetFilters,
    SaveItem
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    updateItem,
    createItem: updateItem
  })

  return {
    // State
    currentItems,
    filter,
    total,
    currentPage,
    listLoading,

    // Actions
    SetFilters,
    FetchItems,
    SetCurrentPage,
    SaveItem
  }
})
